module.exports = __webpack_public_path__ + "media/application/images/svgs/vimeo-b5cf36d6317c695d28a0d5b658457089.svg";